export default "__VITE_ASSET__BqwMbBuY__"